import { render, staticRenderFns } from "./Logotype.vue?vue&type=template&id=35b040f7&"
import script from "./Logotype.vue?vue&type=script&lang=ts&"
export * from "./Logotype.vue?vue&type=script&lang=ts&"
import style0 from "./Logotype.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports